import type { AlertLogSeverity, LogsSummaryMetrics } from '../data-access/logs.api';

export function formatCostByProjectName(projectName: string | null | undefined): string {
  const trimmed = projectName?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : 'Unknown';
}

export function formatLogLabel(value: string): string {
  const raw = value.replace(/_/g, ' ').trim();
  return raw.replace(/\b\w/g, c => c.toUpperCase());
}

export function formatCount(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString();
}

export function formatLatencyMs(value: number | null | undefined): string {
  if (value == null) return 'N/A';
  return `${Math.round(value)} ms`;
}

export function alertSeverityClass(severity: AlertLogSeverity): string {
  return `realtime-monitoring-tab__severity realtime-monitoring-tab__severity--${severity.toLowerCase()}`;
}

export type KpiCard = { label: string; value: string };

export function buildKpiCards(summary: LogsSummaryMetrics): KpiCard[] {
  return [
    { label: 'Total API Calls', value: formatCount(summary.total_calls) },
    { label: 'Total Projects', value: formatCount(summary.total_projects) },
    { label: 'Unique Users', value: formatCount(summary.unique_users) },
    { label: 'High/Critical Alerts', value: formatCount(summary.high_alerts) },
    { label: 'Average Latency', value: formatLatencyMs(summary.avg_latency_ms) },
    { label: 'Maximum Latency', value: formatLatencyMs(summary.max_latency_ms) }
  ];
}
